import type { BattleMode } from "@loot-os/api-contract";
import { Badge } from "@loot-os/ui/components/badge";

import { BATTLE_MODE_LABEL, BATTLE_MODE_RULE } from "../../lib/battleModes.js";

export function BattleModeBadge({ mode }: { mode: BattleMode }) {
  return (
    <Badge variant={mode === "crazy" ? "destructive" : "secondary"} title={BATTLE_MODE_RULE[mode]}>
      {BATTLE_MODE_LABEL[mode]}
    </Badge>
  );
}
